import { useCallback, useState } from "react";
import { Dialog } from "@/components/popups/Dialog";
import { NicheSelector } from "@/components/popups/NicheSelector";
import { updateNiches } from "./utils";
import { useData } from "./hooks";
import { Loader } from "@/components/UI/Loader";
import { IEditNichesDialogProps } from "@/common/buses/popups/popup-types";
import { onCloseEditGifNichesPopup } from "@/components/popup-dispatcher/PopupDispatcher";
import InfiniteScroll from "react-infinite-scroll-component";

export const EditNichesDialog = ({ gifId, role }: IEditNichesDialogProps): JSX.Element => {
  const [selected, setSelected] = useState<string[]>();

  const { gif, niches, isLoading, isError, hasMore, handleFetchMore } = useData({ gifId, role });

  const handleChange = useCallback((ids: string[]): void => {
    setSelected(ids);
  }, []);

  const handleClose = useCallback(() => {
    onCloseEditGifNichesPopup();
  }, []);

  const handleSave = useCallback(async () => {
    if (!selected) {
      handleClose();
      return;
    }

    await updateNiches(gifId, selected, handleClose);
  }, [selected, gifId, handleClose]);

  const buttons = () => (
    <button className="button primary" onClick={handleSave} aria-label="save button">Save</button>
  );

  return (
    <Dialog
      onClose={handleClose}
      title="Change gif niches"
      className="editNichesDialog"
      buttons={buttons()}
    >
      <InfiniteScroll
        next={handleFetchMore}
        hasMore={hasMore}
        loader={<></>}
        dataLength={niches.length}
        scrollableTarget="dialogContent"
      >
        <NicheSelector
          niches={niches}
          selected={selected || gif?.niches || []}
          onChange={handleChange}
        />
      </InfiniteScroll>

      {
        isLoading && <Loader/>
      }

      {
        isError && <div>Could not get niches, please try again.</div>
      }
    </Dialog>
  );
};
